const isCustomerLaneBoard = (
  board:
    | PerformanceBoardTypes.Board
    | DriverPerformanceBoard
    | CustomerLaneBoard
    | GeneralBoard
    | undefined,
): board is CustomerLaneBoard => {
  return !!board && board.category === 'Customer Lane Commitments';
};

export default isCustomerLaneBoard;
